module.exports = __webpack_public_path__ + "static/media/landing-grow-followers.9217bb5f.png";